import {
    GET_ATTENDEE_PAGE_DATA,
    CLEAR_ATTENDEE_PAGE_DATA,
    REQUEST_TRANSCRIPT_PENDING,
    REQUEST_TRANSCRIPT_SUCCESS,
    SET_ATTENDEE_PAGE_EVENT_TYPE
    // REQUEST_TRANSCRIPT_FAILED
} from "../actiontypes";

const INITIAL_STATE = {
    eventDetails: {},
    attendeeActivity: {},
    transcriptData: {
        isPending: false,
        data: [],
        errors: ""
    },
    eventType: ""
};

/* AttendeePageReducer => 
    GET_ATTENDEE_PAGE_DATA - Adds All Attendee Page Data
    CLEAR_ATTENDEE_PAGE_DATA - Clears All Attendee Page Data

*/
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ATTENDEE_PAGE_DATA:
            return {
                ...state,
                eventDetails: action.payload.eventDetails,
                attendeeActivity: action.payload.attendeeActivity
            };
        case CLEAR_ATTENDEE_PAGE_DATA:
            return {
                ...state,
                ...INITIAL_STATE
            };
        case REQUEST_TRANSCRIPT_PENDING:
            return {
                ...state,
                transcriptData: { ...state.transcriptData, isPending: true }
            };
        case REQUEST_TRANSCRIPT_SUCCESS:
            return {
                ...state,
                transcriptData: {
                    isPending: false,
                    data: action.payload,
                    errors: ""
                }
            };
        case SET_ATTENDEE_PAGE_EVENT_TYPE:
            return {
                ...state,
                eventType: action.payload
            };
        // case REQUEST_TRANSCRIPT_FAILED:
        //     return { ...state, error: action.payload, isPending: false };
        default:
            return state;
    }
};
